export default __webpack_public_path__ + "static/media/1.d380f77b.jpg";